import React, { Component } from "react";
import { useSelector } from "react-redux";
import { enhanceWithCollapsible } from "../Collapsible/Collapsible";
import {
  CalendarIcon,
  InfoIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  CreditCardIcon,
  ArrowRightIcon,
  ArrowDropDownIcon,
} from "../../theme/assets";
import { Calendar, DateInfo, Amount, BookableErrorMessage, ConditionBadge } from "~/components";
import classnames from "classnames";
import styles from "./Inventory.scss";
import { withState } from "recompose";
import styled from "styled-components";
import { defineMessages, injectIntl, FormattedMessage, FormattedNumber } from "react-intl";
import constants from "../../utils/constants";
import { executeEvent } from "../../utils/misc";
import { withSessionData } from "../../utils/session";
import Scroll from "react-scroll";
import {
  CancellationMessage,
  Conditions,
  InventoryLine,
  MealPlanDetails,
  Tier,
} from "@witbooking/react-components";
import MaxCartItemsModal from "./MaxCartItemsModal";
import { pushAddToCartEvent } from "../../helpers/EnhancedEcommerce";
import { onlineStoreHidePriceSelector } from "../../containers/App/selectors";

const Element = Scroll.Element;

export const msgs = defineMessages({
  availability: {
    id: "inventory.label.availability",
    description: "availability Text",
    defaultMessage: "View availability",
  },
  comparePrices: {
    id: "inventory.compare.prices",
    description: "Option to compare inventory prices",
    defaultMessage: "compare prices",
  },
  mealPlans: {
    id: "groupedinventoryList.compare.mealPlans",
    description: "Meal plans",
    defaultMessage: "Meal plans",
  },
  lastAvailable: {
    id: "inventory.label.lastAvailable",
    description: "Announcement of last available inventory",
    defaultMessage: "Last One!",
  },
  lastQuantityAvailable: {
    id: "inventory.label.lastQuantityAvailable",
    description: "Announcement of last available inventories",
    defaultMessage: "Last",
  },
  cancelableUntilDate: {
    id: "inventory.advice.cancelableUntilDate",
    description: "Advice the date until the inventory is cancelable",
    defaultMessage: "Can be cancelled online until",
  },
  rooms: {
    id: "inventory.label.numberOfRooms",
    description: "Label to announce the number of rooms",
    defaultMessage: "Room/s",
  },
  BOOK: {
    id: "inventory.button.book",
    description: "Button to book a reservation",
    defaultMessage: "BOOK",
  },
  readConditions: {
    id: "inventory.restriction.readConditions",
    description: "Read conditions label",
    defaultMessage: "read conditions",
  },
  night: {
    id: "inventory.night",
    description: "Night",
    defaultMessage: "night",
  },
  bookNow: {
    id: "inventory.hotel_card.bookNow",
    description: "Book now anchor",
    defaultMessage: "book now",
  },
  select: {
    id: "inventory.hotel_card.select",
    description: "Select anchor",
    defaultMessage: "select",
  },
  UNITS: {
    id: "inventory.roomDenomination.units",
    description: "Room denomination for inventory",
    defaultMessage: "Units",
  },
  ROOMS: {
    id: "inventory.roomDenomination.rooms",
    description: "Room denomination for inventory",
    defaultMessage: "Rooms",
  },
  APARTMENTS: {
    id: "inventory.roomDenomination.apartments",
    description: "Room denomination for inventory",
    defaultMessage: "Apartments",
  },
  BUNGALOWS: {
    id: "inventory.roomDenomination.bungalows",
    description: "Room denomination for inventory",
    defaultMessage: "Bungalows",
  },
  CABINS: {
    id: "inventory.roomDenomination.cabins",
    description: "Room denomination for inventory",
    defaultMessage: "Cabins",
  },
  HOUSES: {
    id: "inventory.roomDenomination.houses",
    description: "Room denomination for inventory",
    defaultMessage: "Houses",
  },
  SHIP_CABIN: {
    id: "inventory.roomDenomination.ship_cabins",
    description: "Room denomination for inventory",
    defaultMessage: "Cabins",
  },
  VILLAS: {
    id: "inventory.roomDenomination.villas",
    description: "Room denomination for inventory",
    defaultMessage: "Villas",
  },
  BEDS: {
    id: "inventory.roomDenomination.beds",
    description: "Room denomination for inventory",
    defaultMessage: "Beds",
  },
  UNITS_SINGULAR: {
    id: "inventory.roomDenomination.units.singular",
    description: "Room denomination for units selector",
    defaultMessage: "unit",
  },
  ROOMS_SINGULAR: {
    id: "inventory.roomDenomination.rooms.singular",
    description: "Room denomination for units selector",
    defaultMessage: "room",
  },
  APARTMENTS_SINGULAR: {
    id: "inventory.roomDenomination.apartments.singular",
    description: "Room denomination for units selector",
    defaultMessage: "apartment",
  },
  BUNGALOWS_SINGULAR: {
    id: "inventory.roomDenomination.bungalows.singular",
    description: "Room denomination for units selector",
    defaultMessage: "bungalow",
  },
  CABINS_SINGULAR: {
    id: "inventory.roomDenomination.cabins.singular",
    description: "Room denomination for units selector",
    defaultMessage: "cabin",
  },
  HOUSES_SINGULAR: {
    id: "inventory.roomDenomination.houses.singular",
    description: "Room denomination for units selector",
    defaultMessage: "house",
  },
  SHIP_CABIN_SINGULAR: {
    id: "inventory.roomDenomination.ship_cabins.singular",
    description: "Room denomination for units selector",
    defaultMessage: "cabin",
  },
  VILLAS_SINGULAR: {
    id: "inventory.roomDenomination.villas.singular",
    description: "Room denomination for units selector",
    defaultMessage: "villa",
  },
  BEDS_SINGULAR: {
    id: "inventory.roomDenomination.beds.singular",
    description: "Room denomination for units selector",
    defaultMessage: "bed",
  },
  noDeposit: {
    id: "inventory.roomDenomination.noDeposit",
    description: "No deposit required",
    defaultMessage: "No deposit required",
  },
  DEPOSIT_REQUIRED: {
    id: "inventory.roomDenomination.depositRequired",
    description: "Deposit required",
    defaultMessage: "Deposit required",
  },
  ADVANCE_PAYMENT: {
    id: "inventory.roomDenomination.advancePayment",
    description: "With advance payment",
    defaultMessage: "With advance payment",
  },
  DEPOSIT_NOT_REQUIRED: {
    id: "inventory.roomDenomination.depositNotRequired",
    description: "No deposit required",
    defaultMessage: "No deposit required",
  },
  NO_ADVANCE_PAYMENT: {
    id: "inventory.roomDenomination.noAdvancePayment",
    description: "No advance payment",
    defaultMessage: "No advance payment",
  },
  PAYMENT_AT_ESTABLISHMENT: {
    id: "inventory.roomDenomination.paymentAtEstablishment",
    description: "Payment at establishment",
    defaultMessage: "Payment at establishment",
  },
  TAXES_INCLUDED_FEES_EXCLUDED: {
    id: "checkout.booking_total.VatIncludedTaxesExcluded",
    description: "Taxes included / city tax excluded",
    defaultMessage: "Taxes included / city tax excluded",
  },
  TAXES_AND_FEES_INCLUDED: {
    id: "checkout.booking_total.VatAndTaxesIncluded",
    description: "Taxes and fees included",
    defaultMessage: "Taxes and fees included",
  },
  continue: {
    id: "app.common.continue",
    description: "continue",
    defaultMessage: "continue",
  },
});
/* TODO: Handle currency and number formatting */
/* TODO: Handle active states*/

const RatesContainer = styled.div`
  display: flex;
  flex-flow: column;
`;

const TierMobileContainer = styled.div`
  display: flex;
  margin-bottom: 12px;
  margin-top: 5px;
`;

const TierDesktopContainer = styled.div`
  margin-left: 11px !important;
  margin-bottom: 0 !important;
`;

const StyledTaxesIncludedFeesExcluded = styled.div`
  font-size: 12px;
  font-weight: 400;
  font-style: italic;
  line-height: 16px;
  color: #8f8f8f;
  text-align: left;
`;

const ExpandControl = ({ className, onExpand, expanded, enabled }) =>
  enabled ? (
    <div
      className={classnames("wbkv9-ExpandControl", styles.expandControl, className)}
      onClick={onExpand}>
      <div className={styles.arrowDownIcon}>{expanded ? <ArrowUpIcon /> : <ArrowDownIcon />}</div>
    </div>
  ) : null;

const MobileControls = ({ onExpand, expanded, onConditionsClick, statusCode, onCalendarClick }) => (
  <div className={classnames("wbkv9-MobileControls", styles.mobileControls)}>
    <div className={styles.leftContainer} onClick={onConditionsClick}>
      <div className={classnames("wbkv9-MobileControls-infoIcon", styles.infoIcon)}>
        <InfoIcon />
      </div>
      <div
        className={classnames("wbkv9-MobileControls-calendarIcon", styles.calendarIcon)}
        onClick={onCalendarClick}>
        <CalendarIcon />
      </div>
    </div>

    <div className={styles.rightContainer}>
      <ExpandControl onExpand={onExpand} expanded={expanded} enabled={statusCode === "AVAILABLE"} />
    </div>
  </div>
);
const isDropdownVisible = (mode, inventoryGroup) => {
  if (
    !mode ||
    mode === constants.INVENTORY_MODE.LIST ||
    (inventoryGroup && inventoryGroup.size <= 1)
  ) {
    return false;
  }
  return inventoryGroup && inventoryGroup.size > 1 && mode === constants.INVENTORY_MODE.GROUPED;
};

const InventoryDescription = ({
  mealplan,
  condition,
  onConditionsClick,
  onCalendarClick,
  mode,
  onDropDownClick,
  inventoryGroup,
  handleConditionModal,
  handleMealPlanModal,
  hasDeposit,
  configuration,
  inventoryGroupingCriteria,
  cancelRelease,
  startDate,
  showCancelMsg,
  showBookingOptionSummary,
  showCalendar,
  restrictions,
  cutOffDate,
  inModification,
  availability,
  depositMessage,
  combined,
}) => {
  let groupingType = inventoryGroupingCriteria && inventoryGroupingCriteria.toJS();
  if (inventoryGroupingCriteria && groupingType.length >= 2) {
    groupingType = groupingType.reduce((firstValue, secondValue) => {
      return firstValue + "," + secondValue;
    });
  } else if (inventoryGroupingCriteria && groupingType.length === 1) {
    groupingType = groupingType[0];
  } else {
    groupingType = "";
  }
  return (
    <div className={classnames("wbkv9-InventoryDescription", styles.leftContainer)}>
      <InventoryLine
        condition={condition && condition.get("name")}
        ocupation={configuration && configuration.get("name")}
        pension={typeof mealplan === "string" ? mealplan : mealplan.get("name")}
        handleInventoryActionsMealPlansClick={handleMealPlanModal}
        handleInventoryDescriptionClick={onDropDownClick}
        handleInventoryActionsConditionsClick={onConditionsClick}
        handleInventoryActionsCompareClick={onCalendarClick}
        links={<FormattedMessage {...msgs.readConditions} />}
        compare={<FormattedMessage {...msgs.comparePrices} />}
        mealPlans={<FormattedMessage {...msgs.mealPlans} />}
        depositAndInformation={
          depositMessage !== constants.DEPOSIT_TEXT_CONFIGURATION.NO_TEXT && (
            <FormattedMessage {...msgs[depositMessage]} />
          )
        }
        hasDeposit={!hasDeposit}
        type={groupingType}
        handleConditionClicked={handleConditionModal}
        handleMealPlanClicked={
          typeof mealplan !== "string" &&
          mealplan.get("description") &&
          mealplan.get("description") != ""
            ? handleMealPlanModal
            : undefined
        }
        inventoryGroupVisible={isDropdownVisible(mode, inventoryGroup)}
        showBookingOptionSummary={!showBookingOptionSummary}
        availability={availability}
        showCalendar={showCalendar}
        cancellationMessage={
          <CancellationMessage
            cancellationRelease={cancelRelease}
            reservationStartDate={startDate}
            includeIcon
            restrictions={restrictions}
            cutOffDate={cutOffDate}
          />
        }
        badge={
          <ConditionBadge
            name={condition.get("name")}
            color={condition.get("color")}
            handleModal={handleConditionModal}
            combined={combined}
          />
        }
        inModification={inModification}
      />
    </div>
  );
};

function getStatusDetails(
  status,
  type,
  value,
  labelClassName,
  failedValueClassName,
  successValueClassName
) {
  if (!status) {
    return null;
  }
  return {
    status: status,
    valueType: type,
    value: value,
    labelClassName: labelClassName,
    valueClassName:
      status === constants.BOOKABLE_STATUS.AVAILABLE ? successValueClassName : failedValueClassName,
  };
}

const InventoryRates = ({
  rackRate,
  discountPercentage,
  discountAmount,
  averageRate,
  totalRate,
  availability,
  showAvailabilityAlert,
  currency,
  statusCode,
  statusFilterType,
  statusValue,
  numberOfUnits,
  onCalendarClick,
  numberOfNights,
  expanded,
  showBookingOptionSummary,
  showDiscountsCalculation,
  onRateClick,
  fullWidth,
  roomDenomination,
  handleNumberOfUnitsChange,
  maxBookableRooms,
  intl: { formatMessage } = {},
  disableUnit,
  loyalty,
  deviceType,
  userLoyaltyTier,
  handleModalContent,
  handleCloseModal,
  loyaltyRate,
  linkToLoyaltyLogin,
  taxesText,
}) => {
  const onlineStoreHidePrice = useSelector(onlineStoreHidePriceSelector);
  const showLoyaltyTier =
    loyalty && statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE;
  const loyaltyPrice = numberOfUnits ? loyaltyRate * numberOfUnits : loyaltyRate;
  const isTaxesTextShowable =
    taxesText && statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE;
  return (
    <div className={classnames("wbkv9-InventoryRates", styles.rightContainer)}>
      {statusCode === "AVAILABLE" && (
        <div
          onClick={
            !fullWidth && !showBookingOptionSummary && !showLoyaltyTier ? onRateClick : undefined
          }
          className={classnames(!showBookingOptionSummary && styles.cursorPointer)}>
          {fullWidth && (
            <div
              onClick={!showBookingOptionSummary && !showLoyaltyTier && onRateClick}
              className={classnames(
                "wbkv9-IntentoryRates-labelsContainer",
                styles.labelsContainer
              )}>
              {showAvailabilityAlert && availability > 0 && (
                <div className={styles.lastOnSale}>
                  {availability === 1 && (
                    <span>
                      <FormattedMessage {...msgs.lastAvailable} />
                    </span>
                  )}
                  {availability > 1 && (
                    <span>
                      <FormattedMessage {...msgs.lastQuantityAvailable} /> {availability}!
                    </span>
                  )}
                </div>
              )}
              {showDiscountsCalculation && discountPercentage > 0 && (
                <div
                  className={classnames(
                    "wbkv9-InventoryRates-discountPercentage",
                    styles.discountPercentage
                  )}>
                  -
                  <FormattedNumber
                    value={discountPercentage}
                    style="percent"
                    maximumFractionDigits={2}
                  />
                </div>
              )}
            </div>
          )}
          <div
            className={classnames("wbkv9-IntentoryRates-leftContainer", styles.ratesLeftContainer)}>
            <RatesContainer
              className={classnames(
                styles.ratesLeftContainer,
                `${showLoyaltyTier && styles.ratesLeftWithLoyaltyContainer}`
              )}>
              {showDiscountsCalculation && discountPercentage > 0 && (
                <div
                  className={classnames(
                    "wbkv9-InventoryRates-discountPercentage",
                    styles.discountPercentage,
                    styles.discountPercentageMobile
                  )}>
                  -
                  <FormattedNumber
                    value={discountPercentage}
                    style="percent"
                    maximumFractionDigits={2}
                  />
                </div>
              )}
              <div
                onClick={fullWidth && !showBookingOptionSummary && onRateClick}
                className={classnames(
                  "wbkv9-InventoryRates-availability",
                  styles.firstRow,
                  styles.withGutters,
                  showLoyaltyTier && styles.firstRowLoyalty
                )}>
                {!fullWidth && showAvailabilityAlert && availability > 0 && (
                  <div className={styles.lastOnSale}>
                    {availability === 1 && (
                      <span>
                        <FormattedMessage {...msgs.lastAvailable} />
                      </span>
                    )}
                    {availability > 1 && (
                      <span>
                        <FormattedMessage {...msgs.lastQuantityAvailable} /> {availability}!
                      </span>
                    )}
                  </div>
                )}
                {totalRate > 0 && (
                  <div
                    className={classnames(
                      "wbkv9-InventoryRates-rateContainer",
                      styles.rateContainer
                    )}>
                    <div className={styles.currency}>
                      <span>{currency}</span>
                    </div>
                    {fullWidth &&
                      showDiscountsCalculation &&
                      ((rackRate && rackRate !== totalRate) || discountAmount > 0) && (
                        <span
                          className={classnames(
                            "wbkv9-InventoryRates-strikedPrice",
                            styles.strikedPrice
                          )}>
                          <span>
                            {rackRate >= totalRate + discountAmount && (
                              <FormattedNumber
                                value={rackRate * numberOfUnits}
                                maximumFractionDigits={2}
                                minimumFractionDigits={2}
                              />
                            )}
                            {discountAmount > 0 && totalRate + discountAmount > rackRate && (
                              <FormattedNumber
                                value={(totalRate + discountAmount) * numberOfUnits}
                                maximumFractionDigits={2}
                                minimumFractionDigits={2}
                              />
                            )}
                          </span>
                        </span>
                      )}
                    <Amount
                      amount={totalRate * numberOfUnits}
                      className={styles.rate}
                      decimalClassName={styles.decimals}
                    />
                  </div>
                )}
                {showLoyaltyTier && !onlineStoreHidePrice && (
                  <TierDesktopContainer
                    className={styles.tierDesktopContainer}
                    onClick={event => {
                      // don't add reservation to cart
                      event.preventDefault();
                      event.stopPropagation();
                    }}>
                    <Tier
                      {...loyalty}
                      deviceType={deviceType}
                      price={loyaltyPrice}
                      userLoyaltyTier={userLoyaltyTier}
                      handleModalContent={handleModalContent}
                      handleCloseModal={handleCloseModal}
                      isInventory
                      linkToLoyaltyLogin={linkToLoyaltyLogin}
                    />
                  </TierDesktopContainer>
                )}
              </div>
              {showLoyaltyTier && (
                <TierMobileContainer
                  className={styles.tierMobileContainer}
                  onClick={event => {
                    // don't add reservation to cart
                    event.preventDefault();
                    event.stopPropagation();
                  }}>
                  <Tier
                    {...loyalty}
                    deviceType={deviceType}
                    price={loyaltyPrice}
                    userLoyaltyTier={userLoyaltyTier}
                    handleModalContent={handleModalContent}
                    handleCloseModal={handleCloseModal}
                    isInventory
                    linkToLoyaltyLogin={linkToLoyaltyLogin}
                  />
                </TierMobileContainer>
              )}
              {fullWidth && numberOfNights > 1 && averageRate > 0 && (
                <div
                  onClick={!showBookingOptionSummary && onRateClick}
                  className={classnames(
                    "wbkv9-InventoryRates-pricePerNightContainer",
                    styles.pricePerNightContainer,
                    styles.withGutters
                  )}>
                  <div>
                    <FormattedNumber
                      value={averageRate}
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                    />{" "}
                    /<FormattedMessage {...msgs.night} />
                  </div>
                </div>
              )}{" "}
              {isTaxesTextShowable && (
                <StyledTaxesIncludedFeesExcluded>
                  <FormattedMessage {...msgs[taxesText]} values={{ taxes: null, fees: null }} />
                </StyledTaxesIncludedFeesExcluded>
              )}
            </RatesContainer>
            <div
              className={classnames(styles.control, styles.controlMobile)}
              onClick={onCalendarClick}>
              <span>
                <FormattedMessage {...msgs.comparePrices} />
              </span>
            </div>
          </div>

          {!fullWidth && (discountAmount > 0 || rackRate > 0) && (
            <div
              className={classnames(
                "wbkv9-InventoryRates-discountContainer",
                styles.discountContainer,
                styles.withGutters
              )}>
              {showDiscountsCalculation &&
                ((rackRate && rackRate !== totalRate) || discountAmount > 0) && (
                  <span
                    className={classnames(
                      "wbkv9-InventoryRates-strikedPrice",
                      styles.strikedPrice
                    )}>
                    <span>
                      {rackRate >= totalRate + discountAmount && (
                        <FormattedNumber
                          value={rackRate * numberOfUnits}
                          maximumFractionDigits={2}
                          minimumFractionDigits={2}
                        />
                      )}
                      {discountAmount > 0 && totalRate + discountAmount > rackRate && (
                        <FormattedNumber
                          value={(totalRate + discountAmount) * numberOfUnits}
                          maximumFractionDigits={2}
                          minimumFractionDigits={2}
                        />
                      )}
                    </span>
                  </span>
                )}
              {showDiscountsCalculation && discountPercentage > 0 && (
                <div
                  className={classnames(
                    "wbkv9-InventoryRates-discountPercentage",
                    styles.discountPercentage
                  )}>
                  -
                  <FormattedNumber
                    value={discountPercentage}
                    style="percent"
                    maximumFractionDigits={2}
                  />
                </div>
              )}{" "}
              {/* TODO: CREATE DECIMALs PARSING FUNCTION*/}
            </div>
          )}
          {!fullWidth && numberOfNights > 1 && averageRate > 0 && (
            <div
              className={classnames(
                "wbkv9-InventoryRates-pricePerNightContainer",
                styles.pricePerNightContainer,
                styles.withGutters
              )}>
              <div>
                <FormattedNumber
                  value={averageRate}
                  minimumFractionDigits={2}
                  maximumFractionDigits={2}
                />{" "}
                x <FormattedMessage {...msgs.night} />
              </div>
            </div>
          )}
          {!fullWidth && (
            <span
              className={classnames(
                "wbkv9-InventoryRates-bookNowButton",
                styles.bookNow,
                !showBookingOptionSummary && styles.fastBooking,
                { [styles.disabled]: expanded }
              )}>
              {!showBookingOptionSummary && (
                <span>
                  <FormattedMessage {...msgs.continue} />
                  {!fullWidth && <ArrowRightIcon />}
                </span>
              )}
              {showBookingOptionSummary && (
                <span>
                  <FormattedMessage {...msgs.continue} />
                  {!expanded && <ArrowDownIcon />}
                  {expanded && <ArrowUpIcon />}
                </span>
              )}
            </span>
          )}

          {fullWidth && (
            <div
              className={classnames(
                "wbkv9-InventoryRates-unitSelectorWrapper",
                styles.unitSelectorWrapper,
                `${showLoyaltyTier && styles.unitSelectorWithLoyaltyWrapper}`
              )}>
              {showAvailabilityAlert && availability > 0 && (
                <div className={classnames(styles.lastOnSale, styles.lastOnSaleMobile)}>
                  {availability === 1 && (
                    <span>
                      <FormattedMessage {...msgs.lastAvailable} />
                    </span>
                  )}
                  {availability > 1 && (
                    <span>
                      <FormattedMessage {...msgs.lastQuantityAvailable} /> {availability}!
                    </span>
                  )}
                </div>
              )}
              <div
                className={classnames(
                  "wbkv9-InventoryRates-unitSelectorContainer",
                  styles.unitSelectorContainer
                )}>
                <div
                  className={classnames(
                    "wbkv9-InventoryRates-unitSelector",
                    disableUnit ? styles.unitSelectorDisableUnit : styles.unitSelector
                  )}>
                  <select
                    className={classnames(
                      "wbkv9-DefaultSelector",
                      styles.DefaultSelector,
                      disableUnit ? styles.SelectorWithOutHover : ""
                    )}
                    defaultValue="1"
                    onChange={event => handleNumberOfUnitsChange(event.target.value)}
                    disabled={disableUnit}>
                    {new Array(maxBookableRooms).fill(false).map((ign, idx) => (
                      <option key={idx}>
                        {idx + 1 + " "}

                        {idx + 1 > 1 && formatMessage(msgs[roomDenomination])}

                        {idx + 1 <= 1 && formatMessage(msgs[roomDenomination + "_SINGULAR"])}
                      </option>
                    ))}
                  </select>
                  <div
                    className={classnames(
                      disableUnit ? "" : "wbkv9-InventoryRates-arrowDown",
                      styles.arrowDown
                    )}>
                    {!disableUnit && <ArrowDropDownIcon />}
                  </div>
                </div>
              </div>

              <div
                onClick={!showBookingOptionSummary && onRateClick}
                className={classnames(
                  "wbkv9-InventoryRates-bookNowButton",
                  styles.bookNow,
                  !showBookingOptionSummary && styles.fastBooking,
                  { [styles.disabled]: expanded }
                )}>
                {!showBookingOptionSummary && (
                  <span>
                    <FormattedMessage {...msgs.continue} />
                    {!fullWidth && <ArrowRightIcon />}
                  </span>
                )}
                {showBookingOptionSummary && (
                  <span>
                    <FormattedMessage {...msgs.continue} />
                    {!expanded && <ArrowDownIcon />}
                    {expanded && <ArrowUpIcon />}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <div className={classnames(styles.withGutters)}>
        <div
          className={classnames(
            statusCode === constants.BOOKABLE_STATUS.RESTRICTED && styles.restricted,
            statusCode === constants.BOOKABLE_STATUS.RESTRICTED &&
              "wbkv9-InventoryRates-status--restricted",
            statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE && styles.soldOut,
            statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE &&
              "wbkv9-InventoryRates-status--soldOut"
          )}>
          <BookableErrorMessage
            {...getStatusDetails(
              statusCode,
              statusFilterType,
              statusValue,
              styles.label,
              styles.failed,
              styles.passed
            )}
          />
        </div>

        {statusCode !== "AVAILABLE" && (
          <div
            className={classnames("wbkv9-InventoryRates-availabilityLink", styles.availabilityLink)}
            onClick={onCalendarClick}>
            <FormattedMessage {...msgs.availability} />
          </div>
        )}
      </div>
    </div>
  );
};

const DepositMessage = text => (
  <div className={classnames("wbkv9-BookingSummary-noDeposit", styles.noDeposit)}>
    <div className={styles.icon}>
      <CreditCardIcon />
    </div>
    <div className={styles.iconText}>
      {text}
      <FormattedMessage {...msgs[text]} />
    </div>
  </div>
);

/* TODO: CALCULATE CANCELLABLE DATE Fri 20 Mar 2016*/
const BookingSummary = ({
  onRoomSelect,
  startDate,
  endDate,
  numberOfUnits,
  handleNumberOfUnitsChange,
  maxBookableRooms,
  totalRate,
  intl: { formatNumber } = {},
  currency,
  roomDenomination,
  hasDeposit,
  cancelRelease,
  depositNotRequiredTextConfiguration,
}) => (
  <div className={classnames("wbkv9-BookingSummary", styles.bookingSummary)}>
    <div className={styles.leftContainer}>
      <div className={classnames("wbkv9-BookingSummary-datesInfo", styles.datesInfo)}>
        <DateInfo startDate={startDate} endDate={endDate} />
      </div>
      <CancellationMessage
        cancellationRelease={cancelRelease}
        reservationStartDate={startDate}
        includeIcon
      />
    </div>

    <div className={styles.rightContainer}>
      <div
        className={classnames(
          "wbkv9-BookingSummary-unitSelectorContainer",
          styles.unitSelectorContainer
        )}>
        <div className={classnames("wbkv9-BookingSummary-unitLabel", styles.unitLabel)}>
          <span>
            <FormattedMessage {...msgs[roomDenomination]} />
          </span>
        </div>
        <div className={classnames("wbkv9-BookingSummary-unitSelector", styles.unitSelector)}>
          <select
            defaultValue="1"
            onChange={event => handleNumberOfUnitsChange(event.target.value)}>
            {new Array(maxBookableRooms).fill(false).map((ign, idx) => (
              <option>
                {idx + 1} (
                {formatNumber(totalRate * (idx + 1), {
                  maximumFractionDigits: 2,
                })}{" "}
                {currency})
              </option>
            ))}
          </select>
        </div>
        {!hasDeposit &&
          depositNotRequiredTextConfiguration !== constants.DEPOSIT_TEXT_CONFIGURATION.NO_TEXT && (
            <DepositMessage text={depositNotRequiredTextConfiguration} />
          )}
      </div>
      {/* TODO: DO NOT HARCODE TICKERS!! */}
      <div
        className={classnames("wbkv9-BookingSummary-bookButtonContainer", "bookButtonContainer")}
        onClick={() => onRoomSelect(numberOfUnits)}>
        <button>
          <FormattedMessage {...msgs.BOOK} />
          {!hasDeposit &&
            depositNotRequiredTextConfiguration !==
              constants.DEPOSIT_TEXT_CONFIGURATION.NO_TEXT && (
              <div className={styles.noDepositButton}>{depositNotRequiredTextConfiguration}</div>
            )}
        </button>
      </div>
    </div>
  </div>
);

const CALENDAR_MODAL = "calendar";
const CONDITIONS_MODAL = "conditions";
const MEALPLAN_MODAL = "mealplan";
const MAX_CART_ITEMS_MODAL = "MAX_CART_ITEMS_MODAL";

function calculateGuestNumber(guests) {
  if (guests) {
    return guests.reduce((accummulator, guest) => {
      accummulator += guest.get("quantity"); // eslint-disable-line
      return accummulator;
    }, 0);
  }
  return 2;
}

class Inventory extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      toggleExpand,
      expandedClassName,
      childrenClassName,
      numberOfUnits,
      setNumberOfUnits,
      currency,
      submitBookingForm,
      handleScroll,
      priceCalendar,
      handleCloseModal,
      showBookingOptionSummary,
      showDiscountsCalculation,
      fullWidth,
      showCalendar,
      totalRate,
      getFirstNightCost,
      inventoryGroupingCriteria,
      cancellationPoliciesInfo,
      session,
      availability,
      isCartMaxItemsReached,
      loyalty,
      deviceType,
      userLoyaltyTier,
      depositRequiredTextConfiguration,
      depositNotRequiredTextConfiguration,
      combined,
      linkToLoyaltyLogin,
      taxesText,
      ...props
    } = this.props;
    const expanded = this.props.expanded && showBookingOptionSummary;
    const disableUnit = session && session.disableUnit;
    const showLoyaltyTier =
      loyalty &&
      this.props.statusCode &&
      this.props.statusCode === constants.BOOKABLE_STATUS.AVAILABLE;
    const onRateClick = event => {
      if (isCartMaxItemsReached) {
        return handleModal(event, MAX_CART_ITEMS_MODAL, props.ticker);
      }
      if (!showBookingOptionSummary) {
        event.stopPropagation();
        event.preventDefault();
        pushAddToCartEvent(props.propertyTicker, {
          ticker: props.accommodationTicker,
          title: props.accommodationName,
          configurationName: props.configuration.get("name"),
          mealPlanName: props.mealplan.get("name"),
          conditionName: props.condition.get("name"),
          quantity: numberOfUnits,
          totalRate: totalRate * numberOfUnits,
        });
        return this.props.onRoomSelect(numberOfUnits);
      }
    };
    const handleExpand = event => {
      event.stopPropagation();
      event.preventDefault();
      if (!showBookingOptionSummary) {
        return null;
      }
      handleScroll(props.ticker);

      if (!this.props.expanded) {
        window.wbkAccommodationName = this.props.accommodationName;

        executeEvent(constants.EVENTS.EXPANDED_INVENTORY);
      }

      return toggleExpand(val => !val);
    };
    const avoidExpand = event => {
      event.stopPropagation();
      event.preventDefault();
    };

    const handleNumberOfUnitsChange = units => {
      return setNumberOfUnits(() => parseInt(units, 10));
    };

    const {
      statusCode,
      startDate,
      endDate,
      handleModalContent,
      cancellationRestrictions,
      inModification,
    } = props;

    const conditionSpecificRestrictions =
      cancellationRestrictions && cancellationRestrictions[props.condition.get("ticker")];

    const handleModal = (event, type, ticker) => {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      if (type === CONDITIONS_MODAL) {
        handleModalContent(
          <Conditions.PopupConditions
            data={props.condition.toJS()}
            closeWindow={handleCloseModal}
            restrictions={conditionSpecificRestrictions}
            cancellationPoliciesInfo={
              cancellationPoliciesInfo && cancellationPoliciesInfo[props.condition.get("ticker")]
            }
            checkIn={startDate}
            amount={totalRate}
            currency={currency}
            firstNightCost={getFirstNightCost(ticker)}
            showCancellationTable
            cutOffDate={Date.now()}
          />,
          { hideCloseButton: true, modalWidth: "700px" }
        );
      }
      if (type === MEALPLAN_MODAL) {
        handleModalContent(
          <MealPlanDetails data={props.mealplan.toJS()} closeWindow={handleCloseModal} />,
          { hideCloseButton: true, modalWidth: "700px" }
        );
      }
      if (type === CALENDAR_MODAL) {
        window.wbkAccommodationName = this.props.accommodationName;
        window.wbkConditionName = this.props.condition.get("name");

        executeEvent(constants.EVENTS.COMPARING_PRICES);
        handleModalContent(
          <Calendar
            inventoryNumberOfGuests={calculateGuestNumber(
              this.props.configuration && this.props.configuration.get("guests")
            )}
            initialStartDate={startDate}
            initialEndDate={endDate}
            currency={currency}
            onSubmit={args => {
              handleCloseModal();
              submitBookingForm(args);
            }}
            inventoryTicker={props.ticker}
            propertyTicker={props.propertyTicker}
            priceCalendar={priceCalendar}
            showDiscountsCalculation={showDiscountsCalculation}
            accommoddationName={this.props.accommodationName}
            defaultPrimaryText={this.props.defaultPrimaryText}
            mealplan={this.props.mealplan}
            conditionName={this.props.condition.get("name")}
            handleCloseModal={this.props.handleCloseModal}
            changeConfiguration={this.props.changeConfiguration}
          />,
          { className: "wbkv9-Modal-" + CALENDAR_MODAL, hideCloseButton: true }
        );
      }
      if (type === MAX_CART_ITEMS_MODAL) {
        handleModalContent(<MaxCartItemsModal closeWindow={handleCloseModal} />);
      }
      return null;
    };

    const hasDeposit = () => {
      const payFirstNight = props.condition.get("payFirstNight");
      const earlyCharge = props.condition.get("earlyCharge");
      const minimumCharge = props.condition.get("minimumCharge");
      return (
        (earlyCharge && earlyCharge > 0) || payFirstNight || (minimumCharge && minimumCharge > 0)
      );
    };
    const optionHasDeposit = hasDeposit(props.condition);
    const depositMessage = hasDeposit()
      ? depositRequiredTextConfiguration
      : depositNotRequiredTextConfiguration;
    return (
      <div
        className={classnames(
          "wbkv9-Inventory",
          styles.container,
          statusCode !== "AVAILABLE" ? styles.disabled : "",
          statusCode !== "AVAILABLE" && "wbkv9-Inventory--disabled"
        )}
        onClick={statusCode === "AVAILABLE" && !showLoyaltyTier ? handleExpand : undefined}>
        <Element name={props.ticker} />

        <div
          className={classnames(
            "wbkv9-Inventory-info",
            styles.parent,
            showBookingOptionSummary && styles.cursorPointer
          )}>
          <div className={styles.infoContainer}>
            <InventoryDescription
              {...props}
              showBookingOptionSummary={showBookingOptionSummary}
              startDate={startDate}
              hasDeposit={optionHasDeposit}
              cancelRelease={props.cancelRelease}
              onConditionsClick={event => handleModal(event, CONDITIONS_MODAL, props.ticker)}
              onCalendarClick={event => handleModal(event, CALENDAR_MODAL)}
              handleConditionModal={event => handleModal(event, CONDITIONS_MODAL, props.ticker)}
              handleMealPlanModal={event => handleModal(event, MEALPLAN_MODAL, props.ticker)}
              fullWidth={fullWidth}
              showCalendar={showCalendar}
              restrictions={conditionSpecificRestrictions}
              cutOffDate={Date.now()}
              configuration={this.props.configuration}
              inventoryGroupingCriteria={inventoryGroupingCriteria}
              inModification={inModification}
              availability={availability}
              depositMessage={depositMessage}
              combined={combined}
            />

            <InventoryRates
              {...props}
              currency={currency}
              numberOfUnits={numberOfUnits}
              showBookingOptionSummary={showBookingOptionSummary}
              showDiscountsCalculation={showDiscountsCalculation}
              onCalendarClick={event => handleModal(event, CALENDAR_MODAL)}
              onRateClick={onRateClick}
              expanded={expanded}
              roomDenomination={props.roomDenomination}
              handleNumberOfUnitsChange={handleNumberOfUnitsChange}
              maxBookableRooms={props.maxBookableRooms}
              intl={props.intl}
              fullWidth={fullWidth}
              totalRate={totalRate}
              disableUnit={disableUnit}
              availability={availability}
              loyalty={loyalty}
              userLoyaltyTier={userLoyaltyTier}
              deviceType={deviceType}
              handleModalContent={handleModalContent}
              handleCloseModal={handleCloseModal}
              linkToLoyaltyLogin={linkToLoyaltyLogin}
              taxesText={taxesText}
            />
          </div>

          {/* <ExpandControl className={styles.hideOnMobile} onExpand={handleExpand} expanded={expanded} enabled={statusCode === 'AVAILABLE'} /> */}

          {false && (
            <MobileControls
              onExpand={handleExpand}
              expanded={expanded}
              statusCode={statusCode}
              onConditionsClick={event => handleModal(event, CONDITIONS_MODAL, props.ticker)}
              onCalendarClick={event => handleModal(event, CALENDAR_MODAL)}
            />
          )}
        </div>

        {statusCode === constants.BOOKABLE_STATUS.AVAILABLE && showBookingOptionSummary && (
          <div
            onClick={avoidExpand}
            className={classnames({
              "wbkv9-Inventory-bookingSummaryContainer": true,
              "wbkv9-Inventory-bookingSummaryContainer--expanded": expanded,
              [styles.children]: true,
              [childrenClassName]: true,
              [expandedClassName]: expanded,
            })}>
            <BookingSummary
              onCalendarClick={event => handleModal(event, CALENDAR_MODAL)}
              propertyTicker={props.propertyTicker}
              onRoomSelect={props.onRoomSelect}
              roomDenomination={props.roomDenomination}
              startDate={startDate}
              endDate={endDate}
              numberOfUnits={numberOfUnits}
              totalRate={props.totalRate}
              maxBookableRooms={props.maxBookableRooms}
              handleNumberOfUnitsChange={handleNumberOfUnitsChange}
              intl={props.intl}
              currency={currency}
              hasDeposit={optionHasDeposit}
              cancelRelease={props.cancelRelease}
            />
          </div>
        )}
      </div>
    );
  }
}

//TODO: Correct proptypes
// Inventory.propTypes = {
//   model: PropTypes.object,
//   intl: PropTypes.object,
//   condition: PropTypes.object,
//   statusCode: PropTypes.string,
//   propertyTicker: PropTypes.string,
//   availability: PropTypes.number,
//   maxBookableRooms: PropTypes.number,
//   onRoomSelect: PropTypes.func,
//   startDate: PropTypes.object,
//   endDate: PropTypes.object,
//   totalRate: PropTypes.number,
//   currency: PropTypes.string,
//   ticker: PropTypes.string,
//   handleModalContent: PropTypes.function,
//   roomDenomination: PropTypes.string,
//   cancelRelease: PropTypes.number,
//   expanded: PropTypes.bool,
//   toggleExpand: PropTypes.object,
//   expandedClassName: PropTypes.string,
//   childrenClassName: PropTypes.string,
//   numberOfUnits: PropTypes.number,
//   setNumberOfUnits: PropTypes.func,
//   submitBookingForm: PropTypes.func,
//   handleScroll: PropTypes.func,
//   priceCalendar: PropTypes.number,
//   handleCloseModal: PropTypes.func,
//   roomDetailRepresentationType: PropTypes.string,
//   showBookingOptionSummary: PropTypes.bool,
//   accommodationName: PropTypes.string,
//   showDiscountsCalculation: PropTypes.bool,
//   fullWidth: PropTypes.bool,
//   configuration: PropTypes.object,
//   showCalendar: PropTypes.bool,
//   cancellationRestrictions: PropTypes.array.isRequired,
//   defaultPrimaryText: PropTypes.string,
//   mealplan: PropTypes.string,
//   inventoryGroupingCriteria: PropTypes.string,
//   getFirstNightCost: PropTypes.func,
//   cancellationPoliciesInfo: PropTypes.array,
// };

const enhance = withState("modalType", "toggleModal", false);
const enhance2 = withState("numberOfUnits", "setNumberOfUnits", 1);

export default injectIntl(enhance2(enhance(enhanceWithCollapsible(withSessionData(Inventory)))));
